// Secret metadata and the service map (data-model.md "secrets", "secret_service_map").
//
// INVARIANT (data-model.md, 00-architecture invariant 4): a secret VALUE never enters
// a domain response. This schema is metadata only - it carries NO `ciphertext` and NO
// plaintext, so a secret value is unrepresentable in any tenant-facing shape. The
// ciphertext and the decrypted lease live only behind the SecretsVault port
// (ports/secrets-vault.ts), which decrypts into a short-lived runner lease.
import { z } from "zod";
import { AppId, AccountId, EnvironmentId, SecretRef, SecretServiceMapId } from "../ids.js";
import { Timestamp } from "./common.js";
import { SecretKind, SecretOrigin } from "./enums.js";
/** The safe, tenant-facing view of a vaulted secret: identifiers and metadata, never the value. */
export const SecretMetadata = z.object({
    id: SecretRef,
    accountId: AccountId,
    appId: AppId,
    environmentId: EnvironmentId,
    name: z.string().trim().min(1),
    kind: SecretKind,
    origin: SecretOrigin,
    version: z.int().positive(),
    createdAt: Timestamp,
});
/** Typed map from a service to the secret name it needs, so a missing/misrouted secret is a validation error, not an outage. */
export const SecretServiceMap = z.object({
    id: SecretServiceMapId,
    environmentId: EnvironmentId,
    service: z.string().trim().min(1),
    secretName: z.string().trim().min(1),
});
//# sourceMappingURL=secrets.js.map